import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import { TextAreaProps as Props } from 'src/constants/Interface';

const TextArea = ({ ...props }: Props) => {
  return (
    <Container isError={props.isError}>
      <textarea
        placeholder={props.placeholder}
        value={props.inputValue}
        onChange={(e) => {
          props.onChange(e.target.value);
        }}
        rows={props.rows}
        disabled={props.isDisabeld}
      />
      <Counter>
        {props.inputValue.length}/{props.max}
      </Counter>
    </Container>
  );
};

const Container = styled.div<{ isError: boolean }>`
  box-sizing: border-box;
  position: relative;
  > textarea {
    width: 100%;
    border: 1px solid
      ${({ isError }) => (isError ? StyleConfig.COLOR.SECONDORY : StyleConfig.COLOR.INPUT_BORDER)};
    border-radius: 4px;
    background-color: #fff;
    padding: 12px;
    color: #000;
    font-size: 16px;
    line-height: 1.5;
    &::place-holder {
      color: #919191;
    }
    &[disabled] {
      background-color: ${StyleConfig.COLOR.INPUT_BORDER};
      cursor: not-allowed;
    }
  }
`;

const Counter = styled.p`
  font-size: 10px;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  position: absolute;
  bottom: 8px;
  right: 8px;
`;

export default TextArea;
